import { __assign } from "tslib";
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { getLocationUrl, now } from '@slardar/sdk-web';
import { SDK_NAME, SDK_VERSION } from '../constants';
export var addEnvToSendEvent = function (ev) {
    var extra = {
        url: getLocationUrl(),
        timestamp: now(),
        sdk_version: SDK_VERSION,
        sdk_name: SDK_NAME,
    };
    return __assign(__assign({}, ev), { extra: __assign(__assign({}, extra), (ev.extra || {})) });
};
export var InjectEnvPlugin = function (client) {
    client.on('report', function (ev) {
        return addEnvToSendEvent(ev);
    });
};
//# sourceMappingURL=inject-env.js.map